import { Collection, util } from '@glu/core';
import store from '@glu/store';
import SavedViewsModel from './savedViewsModel';

export default Collection.extend({
  model: SavedViewsModel,

  initialize(models, options) {
    options = options || {};

    this.listenTo(this, {
      'add remove': this.save,
      'change:default': this.enforceSingleDefault
    });

    this.gridName = options.gridName || 'gridDefaultName';
    this.stateModel = options.stateModel;
    this.storage = store.getStorage(options.storage || 'localStorage');

    this.fetch({
      reset: true
    });
  },


  save() {
    const options = {
      error: util.noop,
      success: () => {
        this.trigger('sync', this, this.toJSON());
      }
    };

    return this.sync('create', this, options);
  },

  enforceSingleDefault(model, value) {
    if (!value) {
      return; // if the model was changed to not default, do nothing
    }

    this.each((otherModel) => {
      if (otherModel !== model) {
        otherModel.set({
          default: false
        });
      }
    }, this);

    this.save(); // save when all models are done changing
  },

  getDefaultModel() {
    const defaultModel = this.findWhere({
      default: true
    });

    return defaultModel || this.stateModel;
  },

  // override this method to add your own server-side persistence
  // note that the current implementation does not return a jqXHR object
  sync(method, collection, options) {
    if (!this.storage) {
      options.error();
      return;
    }

    if (method === 'read') {
      const data = this.storage.get(this.gridName) || [];
      options.success(data);
    }

    if (method === 'create') {
      this.storage.set(this.gridName, this.toJSON());
      options.success();
    }
  }
});
